import { render, staticRenderFns } from "./UserCreate.vue?vue&type=template&id=1e587e50&"
import script from "./UserCreate.vue?vue&type=script&lang=js&"
export * from "./UserCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e587e50')) {
      api.createRecord('1e587e50', component.options)
    } else {
      api.reload('1e587e50', component.options)
    }
    module.hot.accept("./UserCreate.vue?vue&type=template&id=1e587e50&", function () {
      api.rerender('1e587e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/users/views/UserCreate.vue"
export default component.exports